import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../core/store/store';
import { usePanelAccess } from '../../context/PanelAccessContext';
import PanelHubGrid from '../../components/PanelHubGrid';

const PanelCmHubV1: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { loading, hasAccessToSection } = usePanelAccess();
  const roleId = currentUser?.roles_id;
  const canEnterHub = hasAccessToSection('salon_cm');

  useEffect(() => {
    if (!loading && currentUser && !canEnterHub) {
      navigate('/panel/dashboard', { replace: true });
    }
  }, [loading, currentUser, canEnterHub, navigate]);

  if (!currentUser || loading || !canEnterHub || roleId !== 1) {
    return null;
  }

  return (
    <PanelHubGrid
      description="Acces complet plateforme : configuration, maintenance, sauvegardes, referent CM et roles individuels."
      cards={[
        { to: '/panel/joueurs',           title: 'Joueurs',                description: 'Liste, fiches et statut premium.',                      accent: 'sky'    },
        { to: '/panel/moderation',        title: 'Moderation',             description: 'Signalements et sanctions joueurs.',                    accent: 'yellow' },
        { to: '/panel/scenarios',         title: 'Scenarios & CTA',        description: 'CTA en cours, scenarios, categories et radio ANTARES.', accent: 'cyan'   },
        { to: '/panel/logs',              title: 'Logs & securite',        description: 'Synthese et logs d\'authentification complets.',        accent: 'emerald'},
        { to: '/panel/config',            title: 'Configuration metier',   description: 'Personnel, vehicules, batiments, competences...',       accent: 'amber'  },
        { to: '/panel/cm/maintenance',    title: 'Maintenance systeme',    description: 'Mode maintenance et message public.',                   accent: 'amber'  },
        { to: '/panel/system/backup',     title: 'Sauvegardes',            description: 'Backup et restauration serveur.',                       accent: 'slate'  },
        { to: '/panel/cm/referent',       title: 'Referent CM',            description: 'Acces roles, referents, codes invitation.',             accent: 'sky'    },
        { to: '/panel/roles/individual',  title: 'Roles individuels',      description: 'Attributions roles hors defaut global.',                accent: 'violet' },
        { to: '/panel/roles/default-access', title: 'Acces panel par role', description: 'Matrice des sections pour chaque role.',              accent: 'violet' },
        { to: '/panel/users/roles',       title: 'Roles utilisateurs',     description: 'Changer le role d\'un compte.',                        accent: 'sky'    },
        { to: '/panel/admin',             title: 'Espace administrateur',  description: 'Raccourcis admin.',                                     accent: 'sky'    },
        { to: '/panel/modo',              title: 'Espace moderateur',      description: 'Raccourcis moderation.',                               accent: 'yellow' },
      ]}
      columns={2}
    />
  );
};

export default PanelCmHubV1;
